export default {
	namespaced: true,
	state: {
		preferences: {}
	},
	mutations: {
		setPreferences: function (state, preferences) {
			Object.assign(state.preferences, preferences)
		},
		reset: function (state) {
			Object.assign(state.preferences, {})
		}
	},
	actions: {
		setPreferences: function ({ commit }, preferences) {
			return commit('setPreferences', preferences)
		},
		reset: function ({ commit }) {
			return commit('reset')
		}
	},
	getters: {
		getPreferences: function (state) {
			return state.preferences
		},
	}
}
